@if (nutrientGroup) {
  @if (hasValidData(nutrientGroup)) {
    <!-- Nitrogen -->
    @if (nutrientGroup.nAdviceTxt?.length) {
      <div class="nutrient-card">
        <div class="nutrient-header">
          <div class="nutrient-name">{{ 'BFP.N.Name' | translate }} <span class="chemical-symbol">(N)</span></div>
          @if (nutrientGroup.nRecKgha || nutrientGroup.nMinKgha) {
            <div class="value-badge" [class.outdated]="isOutdated">
              {{ nutrientGroup.nRecKgha || nutrientGroup.nMinKgha }} kg/ha
            </div>
          }
        </div>
        <div class="nutrient-advice">
          {{ getAdviceText(nutrientGroup.nAdviceTxt ?? [], nutrientGroup.nRecKgha ?? 0) }}
        </div>
      </div>
    }

    <!-- Potassium -->
    @if (nutrientGroup.kAdviceTxt?.length) {
      <div class="nutrient-card">
        <div class="nutrient-header">
          <div class="nutrient-name">{{ 'BFP.K.Name' | translate }} <span class="chemical-symbol">(K₂O)</span></div>
          @if (nutrientGroup.kRecKgha) {
            <div class="value-badge" [class.outdated]="isOutdated">{{ nutrientGroup.kRecKgha }} kg/ha</div>
          }
        </div>
        <div class="nutrient-advice">
          {{ getAdviceText(nutrientGroup.kAdviceTxt ?? [], nutrientGroup.kRecKgha ?? 0) }}
        </div>
      </div>
    }

    <!-- Magnesium -->
    @if (nutrientGroup.mgAdviceTxt?.length) {
      <div class="nutrient-card">
        <div class="nutrient-header">
          <div class="nutrient-name">{{ 'BFP.Mg.Name' | translate }} <span class="chemical-symbol">(MgO)</span></div>
          @if (nutrientGroup.mgRecKgha) {
            <div class="value-badge" [class.outdated]="isOutdated">{{ nutrientGroup.mgRecKgha }} kg/ha</div>
          }
        </div>
        <div class="nutrient-advice">
          {{ getAdviceText(nutrientGroup.mgAdviceTxt ?? [], nutrientGroup.mgRecKgha ?? 0) }}
        </div>
        @if (shouldShowMgRecommendation()) {
          <div class="recommendation-badge" [class.outdated]="isOutdated">
            {{ 'BFP.UI.FertilizerAdvice.SupplementaryFertilizationRecommended' | translate }}
          </div>
        }
      </div>
    }

    <!-- Manganese -->
    @if (nutrientGroup.mnAdviceTxt?.length) {
      <div class="nutrient-card">
        <div class="nutrient-header">
          <div class="nutrient-name">{{ 'BFP.Mn.Name' | translate }} <span class="chemical-symbol">(Mn)</span></div>
        </div>
        <div class="nutrient-advice">
          {{ getAdviceText(nutrientGroup.mnAdviceTxt ?? []) }}
        </div>
        @if (shouldShowMnRecommendation()) {
          <div class="recommendation-badge" [class.outdated]="isOutdated">
            {{ 'BFP.UI.FertilizerAdvice.SupplementaryFertilizationRecommended' | translate }}
          </div>
        }
      </div>
    }

    <!-- Boron -->
    @if (nutrientGroup.bAdviceTxt?.length) {
      <div class="nutrient-card">
        <div class="nutrient-header">
          <div class="nutrient-name">{{ 'BFP.B.Name' | translate }} <span class="chemical-symbol">(B)</span></div>
          @if (nutrientGroup.bRecKgha && nutrientGroup.bRecKgha > 0) {
            <div class="value-badge" [class.outdated]="isOutdated">{{ nutrientGroup.bRecKgha }} kg/ha</div>
          }
        </div>
        <div class="nutrient-advice">
          {{ getAdviceText(nutrientGroup.bAdviceTxt ?? [], nutrientGroup.bRecKgha) }}
        </div>
        @if (shouldShowBRecommendation()) {
          <div class="recommendation-badge" [class.outdated]="isOutdated">
            {{ 'BFP.UI.FertilizerAdvice.SupplementaryFertilizationRecommended' | translate }}
          </div>
        }
      </div>
    }

    <!-- Sulfur -->
    @if (nutrientGroup.so3AdviceTxt?.length) {
      <div class="nutrient-card">
        <div class="nutrient-header">
          <div class="nutrient-name">{{ 'BFP.S.Name' | translate }} <span class="chemical-symbol">(SO₃)</span></div>
          @if (nutrientGroup.so3RecKgha && nutrientGroup.so3RecKgha > 0) {
            <div class="value-badge" [class.outdated]="isOutdated">{{ nutrientGroup.so3RecKgha }} kg/ha</div>
          }
        </div>
        <div class="nutrient-advice">
          {{ getAdviceText(nutrientGroup.so3AdviceTxt ?? [], nutrientGroup.so3RecKgha) }}
        </div>
        @if (shouldShowSRecommendation()) {
          <div class="recommendation-badge" [class.outdated]="isOutdated">
            {{ 'BFP.UI.FertilizerAdvice.SupplementaryFertilizationRecommended' | translate }}
          </div>
        }
      </div>
    }
  } @else {
    <mat-card class="nutrient-card error-card">
      <mat-card-content>
        <agr-notification-empty [isEmpty]="true" [showEmptyAction]="false" emptyActionColor="primary" />
      </mat-card-content>
    </mat-card>
  }
}
